import { FC } from 'react';
import GotMailIcon from '../../../../assets/images/svg/GotMailIcon';
import {
  CardContainer,
  CardIconHeader,
} from '../../../../shared/components/card';
import { Button } from '../../../../shared/components/button';
import { NavigationLink } from '../../../../shared/components/utility';

interface GotMailTemplateProps {
  subtitle?: string;
  withBackNav?: boolean;
  onBack: () => void;
}

const GotMailTemplate: FC<GotMailTemplateProps> = ({
  onBack,
  withBackNav = true,
  subtitle = 'Please check your inbox for the link to reset your password',
}) => {
  const handleOnClick = () => {
    onBack();
  };

  return (
    <CardContainer
      className='w-full rounded-lg bg-white shadow'
      header={
        <CardIconHeader
          headerHeight='LARGE'
          icon={<GotMailIcon />}
          title="You've Got Mail"
          subtitle={subtitle}
        />
      }
    >
      <Button
        classes={['mb-10']}
        label='Resend Request'
        theme='PRIMARY'
        type='button'
        onClick={handleOnClick}
      />
      {withBackNav ? (
        <div className='mb-4 flex flex-row items-center justify-center'>
          <NavigationLink
            dest='/'
            label='Back to login'
            color='gray'
          ></NavigationLink>
        </div>
      ) : null}
    </CardContainer>
  );
};

export default GotMailTemplate;
